<router-outlet></router-outlet>

<app-video-call 
  *ngIf="isCallActive && currentCallData"
  [isCallActive]="isCallActive"
  [receiverUid]="currentCallData.clientUid || ''"
  [receiverEmail]="currentCallData.clientEmail || ''"
  (callEnded)="onCallEnded()">
</app-video-call>
